module.exports = __webpack_public_path__ + "static/media/Developmentbanner@3x.a5f8f12d.png";